var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272 240h240V16c0-8.832-7.168-16-16-16H272v240z",
    fill: "#4caf50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240 240V0H16C7.168 0 0 7.168 0 16v224h240z",
    fill: "#f44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240 272H0v224c0 8.832 7.168 16 16 16h224V272z",
    fill: "#2196f3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M272 272v240h224c8.832 0 16-7.168 16-16V272H272z",
    fill: "#ffc107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicrosoft);
export default __webpack_public_path__ + "static/media/icon-microsoft.6e68a05afda7a131ee1948596698f8cb.svg";
export { ForwardRef as ReactComponent };